import { Autocomplete, Checkbox, TextField } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useContext } from "react";
import { ExportRelatorioContext } from "../ExportRelatorioContext";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const Filtros = ({ options }) => {
  const { filtros, setFiltros, setValoresFiltros } = useContext(
    ExportRelatorioContext
  );

  const newOptions = options.sort((a, b) => b.nome.localeCompare(a.nome));

  const allOptions = [
    { nome: "Selecionar Todos", variavel: "selecionarTodos" },
    ...newOptions,
  ];

  const handleChangeAutoComplete = (_, value) => {
    const isSelecionarTodos = value?.some(
      (filtro) => filtro.variavel === "selecionarTodos"
    );

    if (isSelecionarTodos) {
      const isAllSelected = filtros.length === options.length;

      if (isAllSelected) {
        setFiltros([]);
        // IMPORTANTE: Preserva o valor de Contas Contábeis mesmo ao limpar todos os filtros
        setValoresFiltros((prev) => {
          const contasContabeis = prev.find((item) =>
            item.nome === "Contas Contábeis" ||
            item.variavel === "$F{contas_contabil}" ||
            item.variavel === "$F{contas_contabeis}"
          );
          return contasContabeis ? [contasContabeis] : [];
        });
      } else {
        setFiltros(options);
        // IMPORTANTE: Preserva o valor de Contas Contábeis ao selecionar todos os filtros
        setValoresFiltros((prev) => {
          const contasContabeis = prev.find((item) =>
            item.nome === "Contas Contábeis" ||
            item.variavel === "$F{contas_contabil}" ||
            item.variavel === "$F{contas_contabeis}"
          );
          // Adiciona os novos filtros mas preserva o valor de Contas Contábeis se existir
          const novosFiltros = options.filter((opt) =>
            opt.nome !== "Contas Contábeis" &&
            opt.variavel !== "$F{contas_contabil}" &&
            opt.variavel !== "$F{contas_contabeis}"
          );
          return contasContabeis ? [...novosFiltros, contasContabeis] : options;
        });
      }
    } else {
      setFiltros(value ?? []);

      setValoresFiltros((prevValores) => {
        // IMPORTANTE: Preserva o valor de Contas Contábeis se já existir
        const contasContabeisExistente = prevValores.find((item) =>
          item.nome === "Contas Contábeis" ||
          item.variavel === "$F{contas_contabil}" ||
          item.variavel === "$F{contas_contabeis}"
        );

        const novosValores = prevValores.filter((item) =>
          value?.some((filtro) => filtro.variavel === item.variavel)
        );

        const itensAdicionados =
          value?.filter(
            (filtro) =>
              !prevValores.some((item) => item.variavel === filtro.variavel)
          ) || [];

        const resultado = [...novosValores, ...itensAdicionados];

        // CRÍTICO: Se havia um valor de Contas Contábeis e ele foi removido, preserva o valor
        if (
          contasContabeisExistente &&
          !resultado.some(
            (item) =>
              item.nome === "Contas Contábeis" ||
              item.variavel === "$F{contas_contabil}" ||
              item.variavel === "$F{contas_contabeis}"
          )
        ) {
          // Se o filtro de Contas Contábeis foi removido da lista de filtros,
          // mas tinha um valor, preserva o valor (pode ter sido selecionado antes)
          return [...resultado, contasContabeisExistente];
        }

        return resultado;
      });
    }
  };

  return (
    <div>
      <Autocomplete
        sx={{ marginTop: "1rem" }}
        multiple
        options={allOptions || []}
        value={filtros}
        onChange={handleChangeAutoComplete}
        disableCloseOnSelect
        getOptionLabel={(option) => option.nome}
        fullWidth
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.nome}
            </li>
          );
        }}
        renderInput={(params) => <TextField {...params} label="Filtros" />}
      />
    </div>
  );
};

export default Filtros;
